import { Component, forwardRef } from "react";
import Loader from "../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import Pagination from "../../../../utils/pagination";
import { withRouter } from "../../../../utils/withRouter";
import { connect } from "react-redux";
import { fill_action } from "../../../../actions/fillCombo_action";
import AdminDrawer from "../../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../../common_components/header_with_logo";
import "react-datepicker/dist/react-datepicker.css";
import ExhibitorHeader from "../../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../../common_components/exhibitor_module_drawer";
import ExhibitorTopMenu from "../../../../common_components/exhibitor_module_topmenu";
import { getGraphViewAuditTrackerList_action } from "../../../../actions/admin_module_action/preSetupTracker_action/graphView_action";
import {
  exhibitionId,
  hallActionId,
  HallZoneActionId,
  serviceTypeId,
  stallActionId,
  toastError,
  toastSuccess,
} from "../../../../utils/constants";
import Select from "react-select";
import Modal from "react-modal";
import moment from "moment";

import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Legend,
  Title,
  Tooltip,
  LineElement,
  PointElement,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Line } from "react-chartjs-2";
ChartJS.register(
  LineElement,
  PointElement,
  BarElement,
  CategoryScale,
  LinearScale,
  Legend,
  Title,
  Tooltip,
  ChartDataLabels
);

const styles = {
  width: "100%",
};

class GraphView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      StatusID: "",
      hallId: "",
      hallList: [],
      zoneId: "",
      zoneList: [],
      serviceId: "",
      serviceList: [],
      ExhRegNo: "",
      ExhibitorName: "",
      VendorName: "",
      ListIndex: null,
      StatusList: [],
      RoleID: sessionStorage.getItem("RoleIDSS"),
      halls: [],
      grid: [],
      graph1Obj: {},
      graph2Obj: {},
      graph3Obj: {},
      graph4Obj: {},
    };

    this.getVendorAuditTrackerList = this.getVendorAuditTrackerList.bind(this);
  }

  componentDidMount() {
    this.getFillList(hallActionId, this.state.exhibitionID, "", "", "", "");
    this.getFillList(serviceTypeId, this.state.exhibitionID, "", "", "", "");
    this.getVendorAuditTrackerList();
  }

  getFillList(actionID, exhibitionID, moduleID, keyValue, value, from, flag) {
    const { } = this.state;
    this.setState({ isLoading: !flag ? false : true });
    this.props
      .fill_action(actionID, exhibitionID, moduleID, keyValue, value)
      .then((data) => {
        if (data.error != 1) {
          if (actionID === hallActionId) {
            this.setState({ hallList: data.data });
          }

          if (actionID === HallZoneActionId) {
            this.setState({ zoneList: data.data });
          }

          if (actionID === serviceTypeId) {
            this.setState({ serviceList: data.data });
          }
        }
        this.setState({ isLoading: false });
      })
      .catch((e) => {
        console.log(e);
      });
  }

  async getVendorAuditTrackerList() {
    const {
      zoneId,
      ExhibitorName,
      VendorName,
      StatusID,
      hallId,
      ExhRegNo,
      serviceId,
    } = this.state;

    this.setState({ isLoading: true });

    try {
      const data = await this.props.getGraphViewAuditTrackerList_action(
        hallId,
        "",
        ExhRegNo,
        ExhibitorName,
        VendorName,
        StatusID,
        zoneId,
        serviceId
      );

      // Handle API error
      if (data.error === 1) {
        toastError(data.error);
        return;
      }
      const list1 = this.graph1DataConvert(data.data[0]);
      const list2 = this.graph2DataConvert(data.data[1]);
      const list3 = this.graph3DataConvert(data.data[2]);
      const list4 = this.graph4DataConvert(data.data[3]);
      console.log("list2", list2);
      this.setState({
        graph1Obj: list1,
        graph2Obj: list2,
        graph3Obj: list3,
        graph4Obj: list4,
      });
    } catch (err) {
      console.error("Error in getVendorAuditTrackerList:", err);
      toastError(
        "Something went wrong while fetching Hall Manager Work Updation list."
      );
    } finally {
      this.setState({ isLoading: false });
    }
  }

  graph1DataConvert(inputData) {
    const labels = inputData.map(x => `${x.HallName}`);
    return {
      labels,
      datasets: [
        {
          label: "Stall Possession",
          data: inputData.map((x) => x.StallPossessionCount),
          backgroundColor: "#058773",
        },
        {
          label: "Possession Pending",
          data: inputData.map((x) => x.PossessionPendingCount),
          backgroundColor: "#9fd9d0",
        },
        {
          label: "NDC ssued",
          data: inputData.map((x) => x.NDCIssuedCount),
          backgroundColor: "#3cbba7",
        },
        {
          label: "No Show",
          data: inputData.map((x) => x.NoShowCount),
          backgroundColor: "#9ea0a1",
        },
      ],
    };
  }

  graph2DataConvert(halls) {
    return {
      labels: halls.map(x => `${x.HallName}`),
      datasets: [
        {
          label: "Count of Completed",
          data: halls.map((x) => x.Completed),
          backgroundColor: "#058773",
        },
        {
          label: "Count of Pending",
          data: halls.map((x) => x.TotalStallCount - x.Completed),
          // data: halls.map((x) => x.PendingCount),
          backgroundColor: "#9fd9d0",
        },

      ],
    };
  }

  graph3DataConvert(arr) {
    const labels = arr.map(item => {
      const d = new Date(item.Dates);
      return d.toLocaleDateString("en-GB").split("/").join("-");
    });

    const planned = arr.map(item => item.PlannedCount);
    const actual = arr.map(item => item.ActualCount);

    return {
      labels,
      datasets: [
        {
          label: "Planned",
          data: planned,
          borderDash: [5, 5],
          borderColor: "#058773",
          borderWidth: 2,
          tension: 0.3,
          fill: false,
          pointRadius: 4,
          pointBackgroundColor: "#058773",
        },
        {
          label: "Actual",
          data: actual,
          borderColor: "#3cbba7",
          borderWidth: 2,
          tension: 0.3,
          fill: false,
          pointRadius: 4,
          pointBackgroundColor: "#3cbba7",
        },
      ],
    };
  }

  graph4DataConvert(apiResponse) {
    return {
      labels: apiResponse.map(item => item.Vendor.trim()),
      datasets: [
        {
          label: "Count of Completed",
          data: apiResponse.map(item => item.CompletedCount),
          backgroundColor: "#058773",
        },
        {
          label: "Count of Pending",
          data: apiResponse.map(item => item.PendingCount),
          backgroundColor: "#9fd9d0",
        },
      ],
    };
  }

  handleClear() {
    this.setState(
      {
        AccountID: "",
        StatusID: "",
        hallId: "",
        zoneId: "",
        serviceId: "",
        ExhRegNo: "",
        ExhibitorName: "",
        VendorName: "",
        ExhibitionOtherAreaID: "",
        PossessionStatusID: "",
      },
      () => this.getVendorAuditTrackerList()
    );
  }

  navigateToVendorAndScopofwork(userId, accountId, WorkOrderID) {
    this.props.navigate("/vendorAndScopofwork", {
      state: {
        AccountID: accountId,
        UserId: userId,
        update: true,
        update: true,
        isView: false,
        replicate: false,
        WorkOrderID: WorkOrderID,
        isHallManager: sessionStorage.getItem("RoleIDSS") == 16,
        isWorkUpdation: true,
      },
    });
  }

  graph1() {
    const { graph1Obj } = this.state;
    console.log("graph1Obj---->", graph1Obj)
    // const data = {
    //     labels: [
    //         'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'H7', 'H8', 'H9', 'H10', 'H11', 'H12', 'H13', 'H14', 'H15'
    //     ],
    //     datasets: [
    //         {
    //             label: 'Taken',
    //             data: [80, 90, 100, 70, 85, 90, 95, 100, 110, 120, 100, 105, 90, 85, 95],
    //             backgroundColor: '#59a14f',
    //         },
    //         {
    //             label: 'Pending',
    //             data: [20, 30, 25, 15, 20, 25, 30, 20, 40, 30, 20, 25, 20, 15, 20],
    //             backgroundColor: '#edc948',
    //         },
    //         {
    //             label: 'Not-issued',
    //             data: [10, 15, 20, 10, 10, 15, 10, 15, 20, 20, 10, 15, 10, 10, 10],
    //             backgroundColor: '#bab0ab',
    //         },
    //         {
    //             label: 'Not-issued (Due)',
    //             data: [10, 15, 10, 15, 10, 10, 15, 10, 15, 10, 10, 10, 10, 10, 10],
    //             backgroundColor: '#e15759',
    //         },
    //     ],
    // };

    const options = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        title: {
          display: true,
          text: "Stall Allotment Status (as of Nov 2025)",
          font: { size: 16, weight: "bold" },
        },
        legend: {
          position: "bottom",
          labels: {
            boxWidth: 20,
            font: { size: 13, weight: "bold" },
          },
        },
        datalabels: {
          color: "white",
          anchor: "center",
          align: "center",
          font: {
            weight: "bold",
            size: 12,
          },
          formatter: (value) => (value > 0 ? value : ""),
        },
      },
      scales: {
        x: {
          stacked: true,
          title: {
            display: true,
            text: "Number of Halls",
            font: { weight: "bold" },
          },
          grid: { display: false },
        },
        y: {
          stacked: true,
          beginAtZero: true,
          title: {
            display: true,
            text: "Number of Stalls",
            font: { weight: "bold" },
          },
          ticks: {
            stepSize: 20,
          },
        },
      },
    };
    if (graph1Obj && Object.keys(graph1Obj).length > 0) {
      console.log("graph1Obj1---------->", graph1Obj);
      return (
        <div
          style={{
            width: "100%",
            height: "400px",
            maxWidth: "900px",
            margin: "0 auto",
          }}
        >
          <Bar data={graph1Obj} options={options} plugins={[ChartDataLabels]} />
        </div>
      );
    }

    return null;
  }

  graph2() {
    const { graph2Obj } = this.state;
    const data = {
      labels: [
        "H1",
        "H2",
        "H3",
        "H4",
        "H5",
        "H6",
        "H7",
        "H8",
        "H9",
        "H10",
        "H11",
        "H12",
        "H13",
        "H14",
        "H15",
      ],
      datasets: [
        {
          label: "Count of Completed",
          data: [60, 55, 70, 50, 45, 60, 65, 80, 90, 70, 50, 60, 55, 50, 45],
          backgroundColor: "#4e79a7",
        },
        {
          label: "Count of Pending",
          data: [40, 50, 45, 30, 35, 40, 50, 60, 70, 55, 40, 45, 30, 35, 40],
          backgroundColor: "#f28e2b",
        },
      ],
    };

    const options = {
      responsive: true,
      maintainAspectRatio: false, // ✅ allow height to stretch
      plugins: {
        legend: { position: "bottom" },
        datalabels: {
          color: "white",
          anchor: "center",
          align: "center",
          font: { weight: "bold" },
          formatter: (value) => (value > 0 ? value : ""),
        },
      },
      scales: {
        x: {
          stacked: true,
          title: {
            display: true,
            text: "Number of Halls",
            font: { weight: "bold" },
          },
        },
        y: {
          stacked: true,
          title: {
            display: true,
            text: "Number of Stalls",
            font: { weight: "bold" },
          },
          ticks: {
            stepSize: 20,
          },
        },
      },
    };

    if (graph2Obj && Object.keys(graph2Obj).length > 0) {
      return (
        <div
          style={{
            width: "100%",
            height: "400px",
            maxWidth: "900px",
            margin: "0 auto",
          }}
        >
          <Bar data={graph2Obj} options={options} plugins={[ChartDataLabels]} />
        </div>
      );
    }
  }

  graph3() {
    const { graph3Obj } = this.state
    console.log("graph3Obj---------->", graph3Obj);
    // const data = {
    //   labels: [
    //     "26-11-2026",
    //     "27-11-2026",
    //     "28-11-2026",
    //     "29-11-2026",
    //     "30-11-2026",
    //     "01-12-2026",
    //   ],
    //   datasets: [
    //     {
    //       label: "Planned",
    //       data: [100, 200, 300, 500, 700, 850],
    //       borderDash: [5, 5],
    //       borderColor: "#4e79a7",
    //       borderWidth: 2,
    //       tension: 0.3,
    //       fill: false,
    //       pointRadius: 4,
    //       pointBackgroundColor: "#4e79a7",
    //     },
    //     {
    //       label: "Actual",
    //       data: [80, 150, 250, 400, 650, 800],
    //       borderColor: "#f28e2b",
    //       borderWidth: 2,
    //       tension: 0.3,
    //       fill: false,
    //       pointRadius: 4,
    //       pointBackgroundColor: "#f28e2b",
    //     },
    //   ],
    // };

    const options = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: { position: "bottom" },
        tooltip: { enabled: true },
        datalabels: { display: false },
      },
      scales: {
        x: {
          title: {
            display: true,
            text: "Event Date",
            font: { weight: "bold" },
          },
        },
        y: {
          beginAtZero: true,
          title: {
            display: true,
            text: "Number of Stalls",
            font: { weight: "bold" },
          },
          ticks: {
            stepSize: 5,   // 👈 this controls 5,10,15,20
          },
          // max: 20,       // 👈 optional: if you want to force maximum to 20
        },
      },
    };


    if (graph3Obj && Object.keys(graph3Obj).length > 0) {
      return (
        // ✅ Increased height container
        <div
          style={{
            width: "100%",
            maxWidth: "900px",
            height: "400px",
            margin: "0 auto",
          }}
        >
          <Line data={graph3Obj} options={options} />
        </div>
      );
    }
  }

  graph4() {
    const { graph4Obj } = this.state;
    if (!graph4Obj || !graph4Obj.labels?.length) return null;

    const labelCount = graph4Obj.labels.length;

    // 🔹 Horizontal scroll only when many labels
    const enableScroll = labelCount > 6;
    const minChartWidth = enableScroll ? labelCount * 80 : "100%";

    // 🔹 Fixed slim bars (no fat bars)
    const barWidth = labelCount <= 4 ? 18 : 22;

    const data = {
      ...graph4Obj,
      datasets: graph4Obj.datasets.map(ds => ({
        ...ds,
        barThickness: barWidth,
        maxBarThickness: barWidth,
      })),
    };

    const options = {
      responsive: true,
      maintainAspectRatio: false,

      plugins: {
        legend: { position: "bottom" },
        datalabels: {
          color: "white",
          anchor: "center",
          align: "center",
          font: { weight: "bold", size: 11 },
          formatter: v => (v > 0 ? v : ""),
        },
      },

      scales: {
        x: {
          stacked: true,

          offset: true,              // ✅ bar centered in grid box
          categoryPercentage: 0.6,   // ✅ smaller grid width
          barPercentage: 0.5,

          grid: {
            drawBorder: false,
            offset: true,            // ✅ grid box centered
          },

          ticks: {
            autoSkip: false,
            align: "center",
            maxRotation: 30,
            minRotation: 30,
          },

          title: {
            display: true,
            text: "Vendors",
            font: { weight: "bold" },
          },
        },

        y: {
          stacked: true,
          beginAtZero: true,         // ✅ ORIGINAL height behavior
          ticks: { stepSize: 1 },

          grid: {
            drawBorder: false,
          },

          title: {
            display: true,
            text: "Number of Stalls",
            font: { weight: "bold" },
          },
        },
      },
    };

    return (
      <div style={{ width: "100%", overflowX: enableScroll ? "auto" : "hidden" }}>
        {/* 🔹 Keep original height */}
        <div style={{ height: "400px", minWidth: minChartWidth }}>
          <Bar
            data={data}
            options={options}
            plugins={[ChartDataLabels]}
          />
        </div>
      </div>
    );
  }

  render() {
    const {
      isLoading,
      isUpdateModalOpen,
      hallId,
      hallList,
      zoneId,
      zoneList,
      serviceId,
      serviceList,
      ExhibitorName,
      ExhRegNo,
      VendorName,
      RoleID,
    } = this.state;

    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <ToastContainer />
        {RoleID == 16 && <HeaderWithLogo />}
        {/* <ExhibitorDrawer /> */}
        <>
          {/* <AdminDrawer /> */}
          {/*app-content open*/}
          <div
            className="app-content with-dr-container com-height admin-top-space"
            style={{ marginLeft: 0 }}
          >
            <main id="main" class={RoleID == 16 ? "px-3" : "px-1"}>
              <section class="section" style={{ padding: 0 }}>
                <div class="row m-0">
                  <div class="px-0 py-2">
                    <div class="d-flex align-items-end w-100">
                      <div class="col-md-3">
                        <label class="ms-1">Hall</label>
                        <select
                          className="form-control"
                          id="roledb"
                          value={hallId}
                          onChange={(e) =>
                            this.setState({ hallId: e.target.value })
                          }
                        >
                          <option value={""}>Select</option>
                          {hallList.length > 0 &&
                            hallList.map((data) => (
                              <option key={data.HallId} value={data.HallId}>
                                {data.HallName}
                              </option>
                            ))}
                        </select>
                      </div>

                      <div class="col-md-3">
                        <label class="ms-1">Service Partner Company</label>
                        <input
                          type="text"
                          class="form-control form-control-sm w-100"
                          value={VendorName}
                          onChange={(e) =>
                            this.setState({ VendorName: e.target.value })
                          }
                          maxLength={100}
                        />
                      </div>

                      <div class="col-md-3">
                        <label class="ms-1">Services</label>
                        <select
                          className="form-control form-control-sm w-100"
                          id="roledb"
                          value={serviceId}
                          onChange={(e) =>
                            this.setState({ serviceId: e.target.value })
                          }
                        >
                          <option value={""}>Select</option>
                          {serviceList.length > 0 &&
                            serviceList.map((data) => (
                              <option
                                key={data.ServiceID}
                                value={data.ServiceID}
                              >
                                {data.Name}
                              </option>
                            ))}
                        </select>
                      </div>

                      <div class="me-2">
                        <button
                          class="btn btn-aqua"
                          onClick={() => this.getVendorAuditTrackerList()}
                        >
                          Search
                        </button>
                      </div>

                      <div>
                        <button
                          class="btn btn-gray"
                          onClick={() => this.handleClear()}
                        >
                          Clear
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="row m-0">
                    <div className="col-6">
                      <div class="card shadow-md mb-2">{this.graph1()}</div>
                    </div>
                    <div className="col-6">
                      <div class="card shadow-md mb-2">{this.graph2()}</div>
                    </div>
                    <div className="col-6">
                      <div class="card shadow-md mb-2">{this.graph3()}</div>
                    </div>
                    <div className="col-6">
                      <div class="card shadow-md mb-2">{this.graph4()}</div>
                    </div>
                  </div>
                </div>
              </section>
            </main>
          </div>
        </>
      </>
    );
  }
}

export default withRouter(
  connect(null, {
    fill_action,
    getGraphViewAuditTrackerList_action,
  })(GraphView)
);
